var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { store } from './application/store';
import './assets/fonts/style.scss';
import { msalConfig } from './auth-config';
import './localization/i18next';
import './index.scss';
import AppThemeProvider from './ui/theme';
import Loader from './ui/components/loader';
var StyledMaterialDesignContent = styled(MaterialDesignContent)(function () { return ({
    '&.notistack-MuiContent-info': {
        backgroundColor: 'white',
        alignItems: 'center',
        color: 'black',
        '& svg': {
            color: '#05A6F0'
        }
    }
}); });
export var msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(function () {
    var accounts = msalInstance.getAllAccounts();
    if (accounts.length) {
        msalInstance.setActiveAccount(accounts[0]);
    }
    msalInstance.addEventCallback(function (event) {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            var payload = event.payload;
            var account = payload.account;
            msalInstance.setActiveAccount(account);
        }
        else if (event.eventType === EventType.LOGOUT_SUCCESS)
            localStorage.removeItem('AccessToken');
    });
});
var container = (_a = document.getElementById('root')) !== null && _a !== void 0 ? _a : document.createElement('root');
var root = createRoot(container);
root.render(_jsx(Provider, { store: store, children: _jsxs(MsalProvider, { instance: msalInstance, children: [_jsx(Loader, {}), _jsx(BrowserRouter, { children: _jsx(AppThemeProvider, { children: _jsx(SnackbarProvider, { Components: { info: StyledMaterialDesignContent }, children: _jsx(App, {}) }) }) })] }) }));
